// extracted by mini-css-extract-plugin
module.exports = {"header":"src_header__3jKt_","content":"src_content__25hLa","div_buttons":"src_div_buttons__2_O6D"};